import { router } from "@inertiajs/react";
import { useContext, useMemo, useState } from "react";

import SimpleButton from "@/components/Buttons/SimpleButton";
import { BigNumber } from "@/components/Cards/BigNumber";
import FaqCardComponent from "@/components/Cards/FaqComponent";
import CreateConsortiumModal from "@/components/Consortia/CreateConsortiumModal";
import Dropdown from "@/components/Dropdown";
import Layout from "@/components/Layout";
import Typography from "@/components/Typography";
import {
  FiltersContainer,
  HeaderInfo,
  ListSection,
  PageContainer,
} from "@/constants/listIndexStyle";
import { AlertContext } from "@/contexts/Alert";
import { bigNumberFormatter } from "@/utils/bigNumberFormatter";

import ConsortiumCard from "./ConsortiumCard";

const Consortia = ({ info, consortia, conglomeratesOptions }: any) => {
  const [selectedConglomerate, setSelectedConglomerate] = useState<string | null>(null);
  const [createModalOpen, setCreateModalOpen] = useState(false);
  const { showAlert } = useContext<any>(AlertContext);
  const filteredConsortia = useMemo(
    () =>
      consortia.filter(
        (consortium: any) =>
          selectedConglomerate === null || consortium.conglomerate_id === selectedConglomerate,
      ),
    [consortia, selectedConglomerate],
  );

  return (
    <Layout>
      <CreateConsortiumModal
        isOpen={createModalOpen}
        onClose={() => setCreateModalOpen(false)}
        onSaved={(message) => showAlert?.({ message, type: "success" })}
        onError={(message) => showAlert?.({ message, type: "error" })}
      />
      <PageContainer>
        <div className="mb-6 flex items-center justify-between gap-4">
          <Typography variant="h3" color="black">
            SPEs
          </Typography>
          <SimpleButton
            variant="primary"
            className="!w-fit"
            label="Criar SPE"
            onClick={() => setCreateModalOpen(true)}
          />
        </div>
        <HeaderInfo>
          <div className="grid w-full grid-cols-1 justify-between gap-4 pt-5 md:grid-cols-2">
            <BigNumber
              infoTitle="Número de SPEs"
              info={bigNumberFormatter(info.number_of_consortia)}
            />
            <BigNumber
              infoTitle="Número de Distribuidoras"
              info={bigNumberFormatter(info.number_of_distributors)}
            />
          </div>
        </HeaderInfo>

        <ListSection>
          <Typography variant="h6">Lista de SPEs</Typography>
          <FiltersContainer>
            {conglomeratesOptions !== null && (
              <Dropdown
                options={["Todos", ...conglomeratesOptions.map((cg) => cg.name)]}
                onSelect={(value) => {
                  if (value === "Todos") {
                    setSelectedConglomerate(null);
                    return;
                  }
                  setSelectedConglomerate(
                    conglomeratesOptions.find((cg) => cg.name === value)?.id || null,
                  );
                }}
              />
            )}
          </FiltersContainer>
        </ListSection>

        <HeaderInfo>
          {filteredConsortia.length > 0 ? (
            <>
              {filteredConsortia.map((consortium, index) => (
                <ConsortiumCard
                  key={index}
                  name={consortium.name}
                  powerPlantCount={consortium.power_plants_count}
                  onClick={() => router.visit(`/manager/spes/${consortium.id}`)}
                  onInvestmentsClick={() =>
                    router.visit(`/manager/spes/${consortium.id}/investments`)
                  }
                />
              ))}
            </>
          ) : (
            <Typography variant="h6">Não houve resultado para sua filtragem</Typography>
          )}
        </HeaderInfo>

        <div className="mt-10">
          <FaqCardComponent variant="questionSection" />
        </div>
      </PageContainer>
    </Layout>
  );
};

export default Consortia;
